/***************************************************************************
 * 版权所有 (C) 2015, Rapid7 LLC, Boston, MA, USA。
 * 保留所有权利。本材料含有未发布的、受版权保护的
 * 内容，包括 Rapid7 的机密和专有信息。
 **************************************************************************/

/* jshint maxlen: false */
export default {
  insightvmNavMenus: {
    ftux: {
      back: '返回',
      cardLibrary: {
        content: {
          description:
            '制作自己的仪表板，专注于对您最重要的洞察分析。为您的利益相关者汇编制定的视图。',
        },
        title: '制作自己的视图',
      },
      cards: {
        content: {
          description: '探索您的数据，并随着您的综合过滤能力的提高而细化。',
        },
        title: '扩展和过滤',
      },
      dashboards: {
        content: {
          description: '请尝试使用特制的仪表板，针对您的需要提供恰当的信息。',
        },
        title: '仪表板库',
      },
      end: '结束',
      endTour: '结束导览',
      info: {
        description: '随时通过此菜单访问仪表板导览。',
      },
      navigation: {
        content: {
          description: '通过直观仪表板和可视化技术，即时深入了解您的数据。',
        },
        title: '导航',
      },
      next: '下一步',
      ok: '确定',
      steps: '(从 __start__ 开始，在 __end__ 结束)',
      welcome: {
        content: {
          description:
            '体验在下次扫描几天前就能暴露漏洞的实时仪表板，以及。 适应性工作流，按优先顺序排列 IT 安全的必做事项。',
          header: '欢迎使用新版 Nexpose',
        },
        dismiss: '放弃',
        quickTour: '快速导览',
      },
    },
    leftNav: {
      administration: '管理',
      assets: '资产',
      dashboard: '仪表板',
      home: '主页',
      policies: '政策',
      projects: '项目',
      reports: '报告',
      tickets: '工单',
      vulnerabilities: '漏洞',
    },
    topNav: {
      assetGroup: '资产组',
      changePassword: '更改密码',
      create: '创建',
      dynamicAssetGroup: '动态资产组',
      help: '帮助',
      logoff: '注销',
      report: '报告',
      search: '搜索',
      site: '场所',
      support: '支持',
      tags: '标签',
      tour: '导览',
      userPreferences: '用户偏好',
    },
  },
};
